import "./DeleteButton.less";

import * as React from "react";

import { Button as AntButton, Popconfirm, Modal } from 'antd';

import { AuthorizedComponent } from "components/general/AuthorizedComponent";
import { IBaseProps } from "lib/data/interfaces";

interface IDeleteButtonProps extends IBaseProps {
	tooltip?: string;
	actionText?: string;
	isLoading?: boolean;
	isDisabled?: boolean;
	onClick?: (event: React.SyntheticEvent) => void;
	onMouseOver?: (event: React.SyntheticEvent) => void;
	onMouseOut?: (event: React.SyntheticEvent) => void;
}

interface IDeleteButtonState {
	confirmModalVisible: boolean;
}


export class DeleteButton extends React.Component<IDeleteButtonProps, IDeleteButtonState> {

	public deleteButton = React.createRef();

	constructor(props: IDeleteButtonProps) {
		super(props);
		this.state = {
			confirmModalVisible: false
		};
	}
	public buttonClicked = () => {
		this.setState({ confirmModalVisible: true });
	}

	public modalExited = () => {
		this.setState({ confirmModalVisible: false })
		if (this.props.onMouseOut) {
			this.props.onMouseOut({ target: this.deleteButton });
		}
	}

	public deleteConfirmed = () => {
		if (this.props.onClick) {
			this.props.onClick({ target: this.deleteButton });
		}
		this.modalExited();
	}
	public render = () => (
		<AuthorizedComponent>
			<div className="delete-button-wrapper">
				<AntButton
					ref={this.deleteButton}
					loading={this.props.isLoading}
					disabled={this.props.isDisabled}
					onMouseOver={this.props.onMouseOver}
					onMouseOut={this.state.confirmModalVisible ? () => { } : this.props.onMouseOut}
					onClick={this.buttonClicked}
					type="default"
					className="delete-button"
					shape="circle"
					icon="delete"
					size={"small"}
				/>
				{this.props.actionText ? <div className='ant-button-action-text'>{this.props.actionText}</div> : ""}
				<Modal
					visible={this.state.confirmModalVisible}
					onCancel={this.modalExited}
					onOk={this.deleteConfirmed}
					footer={[
						<AntButton
							key="Cancel"
							onClick={this.modalExited}
						>
							Cancel
						</AntButton>,
						<AntButton key="Delete" type="danger" onClick={this.deleteConfirmed}>
							Delete
						</AntButton>,
					]}
					className="delete-confirm-modal">
					Deletion is permenant, are you sure you want to continue?
				</Modal>
			</div>
		</AuthorizedComponent>
	)
}
